var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02399 0.167392C7.24713 -0.0557973 7.60951 -0.0557973 7.83264 0.167392C8.05579 0.390581 8.05579 0.753041 7.83264 0.97623L4.80866 3.99911L7.83086 7.02377C8.054 7.24696 8.054 7.60942 7.83086 7.83261C7.60772 8.0558 7.24534 8.0558 7.0222 7.83261L4 4.80795L0.976012 7.83082C0.752873 8.05401 0.390494 8.05401 0.167355 7.83082C-0.0557849 7.60763 -0.0557849 7.24517 0.167355 7.02198L3.19134 3.99911L0.16914 0.974445C-0.0539998 0.751255 -0.0539998 0.390581 0.16914 0.167392C0.392279 -0.0557973 0.754658 -0.0557973 0.977798 0.167392L4 3.19027L7.02399 0.167392Z",
    fill: "#1D1F2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.a790561ccd0b99303bf3efb2394d28ca.svg";
export { ForwardRef as ReactComponent };